export default __webpack_public_path__ + "static/media/timer_green.7f80049a.svg";